import React from 'react'
import { Link,useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CContainer,
	CHeader,
	CHeaderDivider,
	CImage,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
	//CSpinner,CBadge,
	CTooltip,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import {
	MyKalendercheck
} from '../../components/index'
import { UFunc,cBulanPendek } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Headersubdashboard = (props) => {
	const { 
		setSessionaktif,setLoading, showToast 
	} = props 

	//--DOM--/
	const uNavigate 			= useNavigate()
	const uDispatch 			= useDispatch()
	//--END DOM--/

	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uHeaderActionObj  		= useSelector(state => state.gInitHeaderAction)
	const [uEfekview,setEfekview] 	= React.useState(false);
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uCabangArr				= JSON.parse(localStorage.getItem("cabanglist")||"[]");
	const uKeywordObj				= JSON.parse(localStorage.getItem("listkeyword")) || {};

	const [uJmlBadge,setJmlBadge]	= React.useState(0);//--TIDAK_DIPAKAI--/
	const [uDataformObj,setDataformObj] 	= React.useState({});
	const uInitCabangid				= localStorage.getItem("lastcabangid");
	const uCabanguserArr			= uTokenObj.userhak==="FREEROLE"
			? uCabangArr : (uCabangArr.filter(vItems=>(uTokenObj.user_cabangarr||[]).includes(vItems.id)));

	const uTglnowDT		= new Date();
	const uTglsatunowDT	= new Date(uTglnowDT.getFullYear(),uTglnowDT.getMonth(),1);
	const uISfilternow	= UFunc.DbDate(uTglsatunowDT) === uDataformObj.tgl_filter
			&& parseInt(uInitCabangid) === (parseInt(uDataformObj.id_cabang)||0);

	React.useEffect(()=>{
		return () => {
			/*setDataformObj({})
			uKeywordObj.filter_dashboard = undefined;
	    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
			uDispatch({type: "set", gInitHeaderAction: {}});//-->HARUS_DIKOSONGIN_DULU_BIAR_ADA_EFFECT--*/
		}
	},[])
	React.useEffect(()=>{
		const vHeaderTmpObj	= uHeaderActionObj;
		uDispatch({type: "set", gInitHeaderAction: {}});//-->HARUS_DIKOSONGIN_DULU_BIAR_ADA_EFFECT--/

		//---SAVE_KEYWORD--/
		uKeywordObj.filter_dashboard = uDataformObj;
    	localStorage.setItem("listkeyword",JSON.stringify(uKeywordObj));
		//---END SAVE_KEYWORD--/

		vHeaderTmpObj.isHeaderView = true;
		uDispatch({type: "set", gInitHeaderAction: vHeaderTmpObj});
	},[uEfekview])//-*/
	React.useEffect(()=>{
		if(uDataformObj.id_cabang===undefined) {
			setDataformObj({...uDataformObj,id_cabang:uInitCabangid})
		}
		if(uDataformObj.tgl_filter===undefined) {
			const vTglNow	= new Date();
			setDataformObj({...uDataformObj,
				tgl_filter: UFunc.DbDate(new Date(vTglNow.getFullYear(),vTglNow.getMonth(),1))
			})
		}
	},[uDataformObj,
	uDataformObj.id_cabang,
	uDataformObj.tgl_filter
	]);

	//console.log("Headersubdashboard - uActiveroute => "+(uActiveroute));
	return (
		<>
		<div className="d-none d-lg-block">
		<small>{uBahasaObj["menus_"+(uActiveroute||"").toLowerCase()]||""}</small>
		</div>
		
		<CForm className="d-flex align-items-center">
			<Link onClick={()=>setEfekview(!uEfekview)} className="d-none me-2 classcursorpointer classikon classikonreset"/>

			{(!uISfilternow) ? (
				<CTooltip className="d-none d-lg-block" content="--Kalender Klinik">
				<Link to="/subantrian/agendaklinik" className="me-2">
				<CImage src={pjson.homepage+"api/images/menus_agendaklinik.png"} height={35}/>
				</Link>
				</CTooltip>
			) : (
			<>
			<MyKalendercheck height={35} 
				isShowlink={true}
				isShowbadge={true}
				{...props}/>
			<span className="me-2"/>
			</>
			)}

			<CInputGroup className="w-auto" size="sm">
			{(uCabangArr.length > 1 
				&& (uTokenObj.userhak==="FREEROLE" || uTokenObj.userhak==="ADMIN")
			) && (
			<>
			<CFormSelect size="sm"
				className="w-auto d-none d-md-block"
				value={uDataformObj.id_cabang}
				onChange={(e)=>{uDataformObj.id_cabang=e.target.value;setEfekview(!uEfekview)}}
				id="inpcabangid">
				{uCabanguserArr.map((vItems,vKeys)=>{
				return (
				<option value={vItems.id} key={vKeys}>{(vItems.cabang_nama||"").toUpperCase()}</option>
				)				
				})}
			</CFormSelect>

			<CDropdown className="d-md-none">
				<CDropdownToggle className="border px-2" color="transparent">
				<b>{(()=>{
					const vCabangidx = UFunc.getObjectIndeks(uCabanguserArr,uDataformObj.id_cabang);
					return (uCabanguserArr[vCabangidx]||{}).cabang_kode || "UNDF";
				})()}</b>
				</CDropdownToggle>

				<CDropdownMenu className="py-0">
				{uCabanguserArr.map((vItems,vKeys)=>{	
					return (
					<CDropdownItem onClick={()=>{uDataformObj.id_cabang=vItems.id;setEfekview(!uEfekview)}} className="classcursorpointer" key={vKeys}>
						{(vItems.cabang_kode||"").toUpperCase()}
						<span className="mx-1">&middot;</span>
						{(vItems.cabang_nama||"").toUpperCase()}
					</CDropdownItem>
					)			
				})}
				</CDropdownMenu>
			</CDropdown>
			<span className="me-1"/>
			</>
			)}
			<CFormSelect size="sm"
				className="w-auto"
				value={uDataformObj.tgl_filter}
				onChange={(e)=>{uDataformObj.tgl_filter=e.target.value;setEfekview(!uEfekview)}}
				id="inpperiode">
				{[...new Array(6)].map((_,vKeys)=>{
					const vTglNow	= new Date();
					const vMonthidx	= vTglNow.getMonth() - vKeys < 0 
						? (vTglNow.getMonth() - vKeys) + 12 
						: vTglNow.getMonth() - vKeys;
					const vYear		= vTglNow.getMonth() - vKeys < 0 
						? vTglNow.getFullYear()-1 : vTglNow.getFullYear();//-*/

					const vTglsatu	= new Date(vYear,vMonthidx,1);
					const vValue 	= UFunc.DbDate(vTglsatu);
					const vCaption 	= (cBulanPendek[vMonthidx]||"").toUpperCase()+" "+vYear; 

					return (
					<option value={vValue} key={vKeys}>{vCaption}</option>
					)
				})}
				{/*(()=>{
					const vYear 	= 2021;
					const vMonthidx = 9;

					const vValue 	= 
						UFunc.DbDate(new Date(vYear,vMonthidx,1))
					const vCaption 	= (cBulanPendek[vMonthidx]||"").toUpperCase()+" "+vYear; 

					return (
					<option value={vValue}>{vCaption}</option>
					)
				})()*/}
			</CFormSelect>
			</CInputGroup>
		</CForm>
		</>
	)
}

export default Headersubdashboard
